import { render, staticRenderFns } from "./OfferTaskList.vue?vue&type=template&id=29aa3399&scoped=true&"
import script from "./OfferTaskList.vue?vue&type=script&lang=ts&"
export * from "./OfferTaskList.vue?vue&type=script&lang=ts&"
import style0 from "./OfferTaskList.vue?vue&type=style&index=0&id=29aa3399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa3399",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
